import React from 'react';
import Title from '../../components/Title/Title';
import Auxiliary from '../../util/Auxiliary';

const Detail = () => {
  return (
    <Auxiliary>
      <Title>Detail Training</Title>
    </Auxiliary>
  );
}

export default Detail;